/* Neglbutikk ønskeliste – egen løsning uten app.
   Lagres i kundens nettleser (localStorage). Ingen eksterne kall utenom butikkens egne sider. */
(function () {
  'use strict';
  if (window.NBWishlist) return;

  var KEY = 'nb_wishlist_v1';
  var MAX = 100;
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list.slice() } }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function add(h) { var l = read(); if (l.indexOf(h) === -1) { l.unshift(h); write(l); } }
  function remove(h) { var l = read(); var i = l.indexOf(h); if (i > -1) { l.splice(i, 1); write(l); } }
  function toggle(h) { if (has(h)) { remove(h); return false; } add(h); return true; }

  /* Oppdater alle hjerter og tellere på siden */
  function sync() {
    var l = read();
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = l.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Fjern fra ønskeliste' : 'Legg til i ønskeliste');
      var t = b.querySelector('[data-wl-text]');
      var txt = on ? 'Lagt til i ønskeliste ✓' : 'Legg til i ønskeliste';
      if (t && t.textContent !== txt) t.textContent = txt;
    }
    var counts = document.querySelectorAll('[data-wishlist-count]');
    for (var j = 0; j < counts.length; j++) {
      if (counts[j].textContent !== String(l.length)) counts[j].textContent = l.length;
      counts[j].hidden = l.length === 0;
    }
  }

  /* Klikk på hjertet (capture-fase, så kortets lenke ikke åpnes) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(b.getAttribute('data-handle'));
    b.classList.remove('wl-pop');
    void b.offsetWidth;
    if (added) b.classList.add('wl-pop');
    setTimeout(function () { b.classList.remove('wl-pop'); }, 250);
    var card = b.closest('[data-wishlist-grid] > div');
    if (!added && card && !page.shared) {
      card.parentNode.removeChild(card);
      if (!read().length) page.showEmpty();
    }
  }, true);

  /* Nye produktkort som lastes inn senere (filter, "last flere", quickview) */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { mountAll(); }, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });

  /* Synk mellom faner */
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  /* ---------- Ønskeliste-siden ---------- */
  var page = {
    el: null, shared: false,
    showEmpty: function () {
      if (!this.el) return;
      this.el.querySelector('[data-wishlist-empty]').hidden = false;
      this.el.querySelector('[data-wishlist-actions]').hidden = true;
    },
    init: function () {
      this.el = document.querySelector('[data-wishlist-page]');
      if (!this.el) return;
      var self = this;
      var params = new URLSearchParams(location.search);
      var sharedParam = params.get('items');
      var handles = read();

      if (sharedParam) {
        handles = sharedParam.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, MAX);
        self.shared = true;
        var note = document.createElement('div');
        note.className = 'wishlist-page__shared';
        note.innerHTML = 'Du ser en delt ønskeliste. <button type="button" class="btn--text" style="text-decoration:underline;cursor:pointer;background:none;border:0;font:inherit;color:inherit" data-wl-save-all>Lagre alle i min ønskeliste</button>';
        self.el.querySelector('.wishlist-page__head').appendChild(note);
        note.querySelector('[data-wl-save-all]').addEventListener('click', function () {
          var l = read();
          handles.slice().reverse().forEach(function (h) { if (l.indexOf(h) === -1) l.unshift(h); });
          write(l);
          note.textContent = 'Lagret i ønskelisten din ♡';
        });
      }

      var grid = self.el.querySelector('[data-wishlist-grid]');
      var loading = self.el.querySelector('[data-wishlist-loading]');
      if (!handles.length) { loading.hidden = true; self.showEmpty(); return; }

      Promise.all(handles.map(function (h) {
        return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=api-product-grid-item', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .catch(function () { return null; });
      })).then(function (results) {
        var missing = [];
        results.forEach(function (html, i) {
          if (!html) { missing.push(handles[i]); return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var content = tmp.querySelector('[data-api-content]') || tmp;
          var item = document.createElement('div');
          while (content.firstChild) item.appendChild(content.firstChild);
          grid.appendChild(item);
        });
        /* Fjern produkter som er slettet / ikke lenger publisert */
        if (missing.length && !self.shared) {
          write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
        }
        loading.hidden = true;
        if (!grid.children.length) { self.showEmpty(); return; }
        self.el.querySelector('[data-wishlist-actions]').hidden = self.shared;
        sync();
        document.dispatchEvent(new CustomEvent('wishlist:rendered'));
      });

      var shareBtn = self.el.querySelector('[data-wishlist-share]');
      shareBtn.addEventListener('click', function () {
        var url = location.origin + location.pathname + '?items=' + read().map(encodeURIComponent).join(',');
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            shareBtn.textContent = 'Lenke kopiert ✓';
            setTimeout(function () { shareBtn.textContent = 'Del ønskelisten'; }, 2500);
          });
        } else {
          window.prompt('Kopier lenken:', url);
        }
      });
      self.el.querySelector('[data-wishlist-clear]').addEventListener('click', function () {
        if (!window.confirm('Vil du tømme ønskelisten?')) return;
        write([]);
        grid.innerHTML = '';
        self.showEmpty();
      });
    }
  };

  window.NBWishlist = { get: read, add: add, remove: remove, toggle: toggle, has: has, sync: sync };

  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.4-9.3C1.4 8 3.4 4.6 6.9 4.4c2-.1 3.6 1 5.1 2.9 1.5-1.9 3.1-3 5.1-2.9 3.5.2 5.5 3.6 4.3 6.9-1.8 4.7-9.4 9.3-9.4 9.3z"/></svg>';

  function handleFromUrl(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* Hjerte på alle produktkort (kolleksjoner, søk, forsiden, anbefalinger) */
  function mountCardButtons() {
    var cards = document.querySelectorAll('product-grid-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector(':scope > .wl-btn')) continue;
      var a = card.querySelector('a[href*="/products/"]');
      var h = a && handleFromUrl(a.getAttribute('href'));
      if (!h) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl-btn wl-btn--icon';
      b.setAttribute('data-wishlist-toggle', '');
      b.setAttribute('data-handle', h);
      b.setAttribute('title', 'Ønskeliste');
      b.innerHTML = HEART.replace('<svg', '<svg class="wl-btn__icon"');
      card.insertBefore(b, card.firstChild);
    }
  }

  /* Hjerte-ikon med teller i toppmenyen (PC + mobil) */
  function headerLink(cls) {
    var a = document.createElement('a');
    a.href = ROOT + 'pages/onskeliste';
    a.className = cls + ' wl-header-link';
    a.setAttribute('aria-label', 'Ønskeliste');
    a.setAttribute('data-wl-header', '');
    a.innerHTML = '<span class="wl-header-link__iconwrap">' +
      HEART.replace('<svg', '<svg class="wl-header-link__icon" width="28" height="28"').replace(' width="20" height="20"', '') +
      '<span class="wl-count" data-wishlist-count hidden>0</span>' +
      '<span class="wl-header-link__label">Ønskeliste</span></span>';
    return a;
  }
  function mountHeader() {
    var desk = document.querySelectorAll('.header__desktop__buttons');
    for (var i = 0; i < desk.length; i++) {
      if (desk[i].querySelector('[data-wl-header]')) continue;
      var wrap = document.createElement('div');
      wrap.className = 'header__desktop__button';
      if (desk[i].hasAttribute('data-text-items-wrapper')) wrap.setAttribute('data-main-menu-text-item', '');
      wrap.appendChild(headerLink('navlink'));
      desk[i].insertBefore(wrap, desk[i].firstChild);
    }
  }

  /* ---------- Handlekurv-ikon i toppmenyen (samme stil som hjertet) ---------- */
  var CART = '<svg class="wl-header-link__icon wl-cart-icon" viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false"><path d="M2.5 4h2.3l2.4 10.3c.2.7.8 1.2 1.5 1.2h8.7c.7 0 1.3-.4 1.5-1.1L21 8H6.1"/><circle cx="9.6" cy="19.4" r="1.5"/><circle cx="17.1" cy="19.4" r="1.5"/></svg>';

  function cartCount() {
    var el = document.querySelector('[data-header-cart-count]');
    if (!el) return null;
    var m = /(\d+)/.exec(el.textContent || '') || /(\d+)/.exec(el.getAttribute('data-header-cart-count') || '');
    return m ? parseInt(m[1], 10) : 0;
  }
  function mountCart() {
    var links = document.querySelectorAll('.header__desktop__buttons a.navlink--cart, .header__mobile__right a[data-drawer-toggle="drawer-cart"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.querySelector('[data-wl-cart]')) continue;
      a.classList.add('wl-cart-link');
      var w = document.createElement('span');
      w.className = 'wl-header-link__iconwrap';
      w.setAttribute('data-wl-cart', '');
      w.innerHTML = CART + '<span class="wl-count" data-wl-cart-count hidden>0</span>' +
        '<span class="wl-header-link__label">Handlekurv</span>';
      a.insertBefore(w, a.firstChild);
    }
    syncCart();
  }
  function syncCart() {
    var n = cartCount();
    if (n === null) return;
    var c = document.querySelectorAll('[data-wl-cart-count]');
    for (var i = 0; i < c.length; i++) {
      if (c[i].textContent !== String(n)) c[i].textContent = n;
      if (c[i].hidden !== (n === 0)) c[i].hidden = n === 0;
    }
  }
  /* Oppdater telleren når handlekurven endres (temaet sender disse hendelsene) */
  ['theme:cart:change', 'cart:change', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(syncCart, 50); });
  });

  /* ---------- Konto- og søkeikon i toppmenyen (samme stil og størrelse) ---------- */
  var ICON_USER = '<svg class="wl-header-link__icon" viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="4"/><path d="M4 20.5c1.2-3.8 4.3-5.8 8-5.8s6.8 2 8 5.8"/></svg>';
  var ICON_SEARCH = '<svg class="wl-header-link__icon" viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/></svg>';

  function decorate(a, svg, label, inline) {
    if (!a || a.querySelector('[data-wl-icon]')) return;
    a.classList.add('wl-icon-link');
    if (inline) a.classList.add('wl-icon-link--inline');
    var w = document.createElement('span');
    w.className = 'wl-header-link__iconwrap';
    w.setAttribute('data-wl-icon', '');
    w.innerHTML = svg + '<span class="wl-header-link__label">' + label + '</span>';
    a.insertBefore(w, a.firstChild);
  }
  /* Min side: egen side i temaet (erstatter Froonze-kontosiden) */
  var MIN_SIDE = ROOT + 'pages/min-side';
  var ACCOUNT_URL = window.NB_LOGGED_IN === true ? MIN_SIDE : '/customer_authentication/login?return_to=' + encodeURIComponent(MIN_SIDE);
  try {
    if (/\/pages\/konto\/?$/.test(location.pathname)) location.replace(MIN_SIDE);
  } catch (e) {}
  function mountIcons() {
    var loggedIn = window.NB_LOGGED_IN === true;
    var bars = document.querySelectorAll('.header__desktop__buttons');
    for (var i = 0; i < bars.length; i++) {
      var links = bars[i].querySelectorAll('a.navlink');
      for (var j = 0; j < links.length; j++) {
        var a = links[j];
        var href = a.getAttribute('href') || '';
        if (a.hasAttribute('data-popdown-toggle') || /\/search(\?|$)/.test(href)) {
          decorate(a, ICON_SEARCH, 'Søk');
        } else if (/\/account(\/|\?|$)|customer_authentication|pages\/min-side/.test(href)) {
          decorate(a, ICON_USER, loggedIn ? 'Min side' : 'Logg inn');
          a.setAttribute('href', ACCOUNT_URL);
        }
      }
    }
    /* Mobil: Ønskeliste · Logg inn / Min side · Handlekurv til høyre i toppmenyen */
    var navBtn = document.querySelector('.header__mobile__left button.header__mobile__button');
    var navColor = navBtn ? getComputedStyle(navBtn).color : '';
    var right = document.querySelectorAll('.header__mobile__right');
    for (var n = 0; n < right.length; n++) {
      if (right[n].querySelector('[data-wl-m-account]')) continue;
      var cartA = right[n].querySelector('a[data-drawer-toggle="drawer-cart"]');
      if (cartA) cartA.classList.add('wl-m');
      var aa = document.createElement('a');
      aa.href = ACCOUNT_URL;
      aa.className = 'header__mobile__button wl-m';
      aa.setAttribute('aria-label', loggedIn ? 'Min side' : 'Logg inn');
      aa.setAttribute('data-wl-m-account', '');
      decorate(aa, ICON_USER, loggedIn ? 'Min side' : 'Logg inn');
      right[n].insertBefore(aa, cartA || null);
      var ha = headerLink('header__mobile__button wl-m');
      right[n].insertBefore(ha, aa);
    }
    var ms = document.querySelectorAll('.header__mobile .wl-m');
    for (var c2 = 0; c2 < ms.length; c2++) { if (navColor && ms[c2].style.color !== navColor) ms[c2].style.color = navColor; }
    fitMobileRight();
    /* Mobil: «Meny» under ☰-ikonet */
    var burgers = document.querySelectorAll('.header__mobile__left button[data-drawer-toggle="hamburger"]');
    for (var q = 0; q < burgers.length; q++) {
      var bg = burgers[q];
      if (bg.querySelector('[data-wl-menu]')) continue;
      var svgEl = bg.querySelector('svg');
      if (!svgEl) continue;
      var wrapM = document.createElement('span');
      wrapM.className = 'wl-header-link__iconwrap';
      wrapM.setAttribute('data-wl-menu', '');
      bg.insertBefore(wrapM, svgEl);
      wrapM.appendChild(svgEl);
      var lab = document.createElement('span');
      lab.className = 'wl-header-link__label';
      lab.textContent = 'Meny';
      wrapM.appendChild(lab);
      bg.classList.add('wl-menu-btn');
    }
    /* Mobil: kontolenken i menyen (☰) */
    var drawer = document.querySelectorAll('a.drawer__account');
    for (var k = 0; k < drawer.length; k++) {
      decorate(drawer[k], ICON_USER, loggedIn ? 'Min side' : 'Logg inn', true);
      drawer[k].setAttribute('href', ACCOUNT_URL);
    }
  }

  /* Sørg for at Søk og Logg inn alltid er helt innenfor skjermen */
  function fitMobileRight() {
    var r = document.querySelector('.header__mobile__right');
    if (!r || !r.offsetParent) return;
    var prev = parseFloat(r.getAttribute('data-wl-shift') || '0');
    var maxRight = 0;
    var els = r.querySelectorAll('.wl-m, .wl-m .wl-header-link__label');
    for (var i = 0; i < els.length; i++) {
      var b = els[i].getBoundingClientRect();
      if (b.width) maxRight = Math.max(maxRight, b.right + prev);
    }
    var limit = document.documentElement.clientWidth - 6;
    var shift = Math.max(0, Math.ceil(maxRight - limit));
    if (shift !== prev) {
      r.style.transform = shift ? 'translateX(-' + shift + 'px)' : '';
      r.setAttribute('data-wl-shift', String(shift));
    }
    /* Logoen: flytt den inn i det ledige feltet mellom ☰ og ikonene (og gjør den mindre bare hvis det trengs) */
    var l = document.querySelector('.header__mobile__left');
    var box = document.querySelector('.header__mobile .header__logo');
    if (!l || !box) return;
    var logos = box.querySelectorAll('img, svg, .header__logo__text');
    for (var z = 0; z < logos.length; z++) { logos[z].style.maxWidth = ''; logos[z].style.height = ''; }
    box.style.translate = '';
    var logo = null;
    for (var y = 0; y < logos.length; y++) { if (logos[y].getBoundingClientRect().width > 0) { logo = logos[y]; break; } }
    if (!logo) return;
    var lb = l.getBoundingClientRect(), rb = r.getBoundingClientRect(), gb = logo.getBoundingClientRect();
    if (gb.right <= rb.left - 6 && gb.left >= lb.right + 6) return;
    var gap = rb.left - lb.right - 16;
    if (gap < 40) return;
    var w = gb.width;
    if (w > gap) {
      for (var x = 0; x < logos.length; x++) { logos[x].style.maxWidth = Math.floor(gap) + 'px'; logos[x].style.height = 'auto'; }
      gb = logo.getBoundingClientRect();
    }
    var shift = Math.round((lb.right + rb.left) / 2 - (gb.left + gb.right) / 2);
    if (shift) box.style.translate = shift + 'px 0';
  }
  window.addEventListener('resize', function () { fitMobileRight(); });

  /* ---------- Mobil: fast meny nederst (Ønskeliste · Meny · Søk · Handlekurv · Min side) ---------- */
  var ICON_MENU = '<svg class="wl-bnav__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6.5h16M4 12h16M4 17.5h16"/></svg>';
  var ICON_SEARCH_B = '<svg class="wl-bnav__icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/></svg>';
  var ICON_CART_B = '<svg class="wl-bnav__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 4h2.3l2.4 10.3c.2.7.8 1.2 1.5 1.2h8.7c.7 0 1.3-.4 1.5-1.1L21 8H6.1"/><circle cx="9.6" cy="19.4" r="1.5"/><circle cx="17.1" cy="19.4" r="1.5"/></svg>';
  var ICON_USER_B = '<svg class="wl-bnav__icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 20.5c1.2-3.8 4.3-5.8 8-5.8s6.8 2 8 5.8"/></svg>';
  var ICON_HEART_B = '<svg class="wl-bnav__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.6s-7.6-4.6-9.4-9.3C1.4 8 3.4 4.6 6.9 4.4c2-.1 3.6 1 5.1 2.9 1.5-1.9 3.1-3 5.1-2.9 3.5.2 5.5 3.6 4.3 6.9-1.8 4.7-9.4 9.3-9.4 9.3z"/></svg>';

  function openSearch() {
    var ov = document.querySelector('.wl-sov');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'wl-sov';
      ov.innerHTML = '<div class="wl-sov__panel"><form class="wl-msearch" action="' + ROOT + 'search" method="get" role="search">' +
        '<input type="hidden" name="options[prefix]" value="last">' +
        '<label class="wl-msearch__field">' + ICON_SEARCH_B.replace('wl-bnav__icon', 'wl-msearch__icon') +
        '<input type="search" name="q" placeholder="Søk etter produkter…" aria-label="Søk" autocomplete="off"></label>' +
        '</form><button type="button" class="wl-sov__close" aria-label="Lukk">Lukk</button></div>';
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('.wl-sov__close')) closeSearch(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
    }
    ov.classList.add('is-open');
    var inp = ov.querySelector('input[type=search]');
    if (inp) inp.focus();
  }
  function closeSearch() { var ov = document.querySelector('.wl-sov'); if (ov) ov.classList.remove('is-open'); }

  function bnavItem(tag, cls, icon, label, extra) {
    var el = document.createElement(tag);
    el.className = 'wl-bnav__item ' + cls;
    if (tag === 'button') el.type = 'button';
    el.innerHTML = '<span class="wl-bnav__iconwrap">' + icon + (extra || '') + '</span><span class="wl-bnav__label">' + label + '</span>';
    return el;
  }
  function mountMobileBar() {
    var mob = document.querySelector('.header__mobile');
    if (!mob) return;
    /* Bare på mobil: skjul når PC-toppmenyen vises */
    var desk = document.querySelector('[data-header-desktop]') || document.querySelector('.header__inner .header__desktop');
    var isMob = desk ? desk.getBoundingClientRect().height === 0 : mob.getBoundingClientRect().height > 0;
    var html = document.documentElement;
    if (html.classList.contains('wl-mob') !== isMob) html.classList.toggle('wl-mob', isMob);

    var nav = document.querySelector('.wl-bnav');
    if (!nav) {
      var loggedIn = window.NB_LOGGED_IN === true;
      nav = document.createElement('nav');
      nav.className = 'wl-bnav';
      nav.setAttribute('aria-label', 'Hovedmeny');
      var path = location.pathname.replace(/\/$/, '');

      var wl = bnavItem('a', 'wl-bnav--wish', ICON_HEART_B, 'Ønskeliste', '<span class="wl-count" data-wishlist-count hidden>0</span>');
      wl.href = ROOT + 'pages/onskeliste';
      var menu = bnavItem('button', 'wl-bnav--menu', ICON_MENU, 'Meny');
      menu.addEventListener('click', function () {
        var b = document.querySelector('.header__mobile__left button[data-drawer-toggle="hamburger"]') || document.querySelector('[data-drawer-toggle="hamburger"]');
        if (b) b.click();
      });
      var srch = bnavItem('button', 'wl-bnav--search', ICON_SEARCH_B, 'Søk');
      srch.addEventListener('click', openSearch);
      var cart = bnavItem('a', 'wl-bnav--cart', ICON_CART_B, 'Handlekurv', '<span class="wl-count" data-wl-cart-count hidden>0</span>');
      cart.href = ROOT + 'cart';
      var acc = bnavItem('a', 'wl-bnav--account', ICON_USER_B, loggedIn ? 'Min side' : 'Logg inn');
      acc.href = ACCOUNT_URL;

      if (/\/pages\/onskeliste$/.test(path)) wl.classList.add('is-active');
      if (/\/cart$/.test(path)) cart.classList.add('is-active');
      if (/\/pages\/(min-side|faktura)$/.test(path)) acc.classList.add('is-active');
      if (/\/search$/.test(path)) srch.classList.add('is-active');

      [menu, wl, srch, cart, acc].forEach(function (x) { nav.appendChild(x); });
      document.body.appendChild(nav);
      sync();
      syncCart();
    }
    /* Fjern gammelt søkefelt under toppmenyen hvis det finnes fra før */
    var olds = document.querySelectorAll('form.wl-msearch');
    for (var o = 0; o < olds.length; o++) { if (!olds[o].closest('.wl-sov')) olds[o].parentNode.removeChild(olds[o]); }
    fixOverlap();
  }

  /* Be temaet regne ut toppmenyens høyde på nytt én gang etter at ikonene er lagt inn */
  var resized = false;
  function fixOverlap() {
    if (resized) return;
    resized = true;
    setTimeout(function () { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }, 300);
  }
  window.addEventListener('resize', function () { mountMobileBar(); });

  function mountAll() { mountHeader(); mountIcons(); mountCart(); mountMobileBar(); mountCardButtons(); mountProductButton(); sync(); }

  /* Produktside: legg knappen under "Legg i handlekurv" */
  function mountProductButton() {
    var tpl = document.getElementById('wl-product-button');
    if (!tpl || document.querySelector('[data-wl-product-mounted]')) return;
    var target = document.querySelector('[data-section-type="product"] .product__block__buttons') ||
                 document.querySelector('.product__block__buttons');
    if (!target) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-wl-product-mounted', '');
    target.appendChild(node);
  }

  function start() { mountAll(); page.init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
